// extracted by mini-css-extract-plugin
export var chevronPulse = "Scroller-module--chevron-pulse--48f18";
export var fadeInAnimation = "Scroller-module--fadeInAnimation--54086";
export var icon = "Scroller-module--icon--878a6";